import StrapiContent from "@components/common/StrapiContent";
import { RAQ_PAGE_TYPE } from "@components/utils/constants";
import { IArticlePageProps } from "@customTypes/commonResponses";
import DetailsPageSectionsWrapper from "@modules/detailsPage/DetailsPageSectionsWrapper";

const ArticleViewContent = ({
  article,
  topNavigation,
  raqFormType,
}: Omit<IArticlePageProps, "ogImage">): JSX.Element => {
  return (
    <DetailsPageSectionsWrapper
      topNavigation={topNavigation}
      raqFormType={raqFormType}
      pageType={RAQ_PAGE_TYPE.ARTICLE}
      lessTopPadding
    >
      <div className="px-5 desktop:px-0">
        <StrapiContent
          overview={article.Overview}
          description={article.Long_Description}
        />
      </div>
    </DetailsPageSectionsWrapper>
  );
};

export default ArticleViewContent;
